import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const Save_products = async (data) => {
  const { category, subcategory, item, usecase, title } = data || {};

  // 1. Validate inputs
  if (!category?.trim()) return { success: false, error: "Missing category." };
  if (!subcategory?.trim()) return { success: false, error: "Missing subcategory." };
  if (!item?.trim()) return { success: false, error: "Missing item." };
  if (!usecase?.trim()) return { success: false, error: "Missing usecase." };
  if (!title?.trim()) return { success: false, error: "Missing title." };

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const companyuid = Cookies.get("select_company_uid");

  if (!sessiontoken || sessiontoken === "undefined")
    return { success: false, error: "Session expired. Please relogin." };
  if (!guid || guid === "undefined")
    return { success: false, error: "Login expired. Please relogin." };
  if (!companyuid || companyuid === "undefined")
    return { success: false, error: "Please select company." };

  try {
    const tablename = "products";

    // Check if the same category + subcategory + item exists
    const productQuery = query(
      collection(db, tablename),
      where("guid", "==", guid),
      // where("category", "==", category),
      // where("subcategory", "==", subcategory),
      // where("item", "==", item)
    );
    const productSnap = await getDocs(productQuery);

    //if (productSnap.empty) {
      // Product already exists
     // return { success: false, error: "This product already exists." };
    //}

    // Product doesn't exist, create new
    const uid = Randomcode(14);
    const savedata = {
      ...data,
      uid,
      guid,
      companyuid,
      sessiontoken,
      compare:0,
      views:0,
      status:false,
      date_time: new Date(),
    };

    const productRef = doc(collection(db, tablename), uid);
    await setDoc(productRef, savedata);

    return { success: true, dockuid: uid, message: "Product saved successfully." };

  } catch (err) {
    console.error("❌ Error saving document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
